/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const Insurance = {
  path: '/insurance',
  name: 'insurance',
  redirect: { name: 'jijia-order' },
  component: () => import('@/views/insurance/index.vue'),
  children: [
    {
      path: 'wuyou-pay-order',
      name: 'insurance-wuyou-pay-order',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/wuyou/pay-order.vue'),
    },
    {
      path: 'wuyou-order',
      name: 'insurance-wuyou-order',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/wuyou/order-list.vue'),
    },
    {
      path: 'wuyou-invoice-apply',
      name: 'insurance-wuyou-invoice-apply',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/wuyou/apply-invoice.vue'),
    },
    {
      path: 'repair-order',
      name: 'insurance-repair-order',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/repair/order-list.vue'),
    },
    {
      path: 'repair-invoice-apply',
      name: 'insurance-repair-invoice-apply',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/repair/apply-invoice.vue'),
    },
    {
      path: 'jijia-introduce',
      name: 'insurance-jijia-introduce',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/jijia/introduce.vue'),
    },
    {
      path: 'jijia-device-select',
      name: 'insurance-jijia-device-select',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/jijia/device-select.vue'),
    },

    {
      path: 'jijia-insurance-form-page',
      name: 'insurance-jijia-insurance-form-page',
      component: () =>
        import(
          /* webpackChunkName: "insurance" */ '@/views/insurance/jijia/insurance-form-page.vue'
        ),
    },
    {
      path: 'jijia-insurance-form-confirm',
      name: 'insurance-jijia-insurance-form-confirm',
      component: () =>
        import(
          /* webpackChunkName: "insurance" */ '@/views/insurance/jijia/insurance-form-confirm.vue'
        ),
    },
    {
      path: 'jijia-after-submit',
      name: 'insurance-jijia-after-submit',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/jijia/after-submit.vue'),
    },
    {
      path: 'jijia-insurance-list',
      name: 'insurance-jijia-insurance-list',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/jijia/insurance-list.vue'),
    },
    {
      path: 'jijia-insurance-detail',
      name: 'insurance-jijia-insurance-detail',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/jijia/insurance-detail.vue'),
    },
    {
      path: 'jijia-insurance-correct-select',
      name: 'insurance-jijia-insurance-correct-select',
      component: () =>
        import(
          /* webpackChunkName: "insurance" */ '@/views/insurance/jijia/insurance-correct-select.vue'
        ),
    },
    {
      path: 'jijia-pay-check',
      name: 'insurance-jijia-pay-check',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/jijia/pay-check.vue'),
    },
    {
      path: 'jijia-check-material',
      name: 'insurance-jijia-check-material',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/jijia/check-material.vue'),
    },
    {
      path: 'jijia-mini-pay-success',
      name: 'insurance-jijia-mini-pay-success',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/jijia/mini-pay-success.vue'),
    },
    {
      path: 'jijia-pay-success',
      name: 'insurance-jijia-pay-success',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/jijia/pay-success.vue'),
    },
    {
      path: 'jijia-cancel-pay-return',
      name: 'insurance-jijia-cancel-pay-return',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/jijia/cancel-pay-return.vue'),
    },
    {
      path: 'jijia-client-policy',
      name: 'insurance-jijia-client-policy',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/jijia/client-policy.vue'),
    },
    {
      path: 'jijia-insurance-notice-word',
      name: 'insurance-jijia-insurance-notice-word',
      component: () =>
        import(
          /* webpackChunkName: "insurance" */ '@/views/insurance/jijia/insurance-notice-word.vue'
        ),
    },
    {
      path: 'jijia-insurance-refund-word',
      name: 'insurance-jijia-inusrance-refund-word',
      component: () =>
        import(
          /* webpackChunkName: "insurance" */ '@/views/insurance/jijia/insurance-refund-word.vue'
        ),
    },
    {
      path: 'jijia-special-agreement',
      name: 'insurance-jijia-special-agreement',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/jijia/special-agreement.vue'),
    },
    {
      path: 'jijia-test',
      name: 'insurance-jijia-test',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/jijia/test.vue'),
    },
    {
      path: 'mini-pay-middle',
      name: 'insurance-mini-pay-middle',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/jijia/mini-pay-middle.vue'),
    },
    {
      path: 'jijia-order-refund',
      name: 'insurance-service-jijia-order-refund',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/jijia/insurance-refund.vue'),
    },
    {
      path: 'service-charge-order',
      name: 'service-charge-order',
      component: () =>
        import(
          /* webpackChunkName: "insurance" */ '@/views/insurance/service-charge/order-list.vue'
        ),
    },
    {
      path: 'service-charge-invoice-apply',
      name: 'insurance-service-charge-invoice-apply',
      component: () =>
        import(
          /* webpackChunkName: "insurance" */ '@/views/insurance/service-charge/apply-invoice.vue'
        ),
    },
    {
      path: 'nameplate-reissue-order',
      name: 'nameplate-reissue-order',
      component: () =>
        import(
          /* webpackChunkName: "insurance" */ '@/views/insurance/nameplate-reissue/order-list.vue'
        ),
    },
    {
      path: 'nameplate-reissue-invoice-apply',
      name: 'nameplate-reissue-invoice-apply',
      component: () =>
        import(
          /* webpackChunkName: "insurance" */ '@/views/insurance/nameplate-reissue/apply-invoice.vue'
        ),
    },
    {
      path: 'three-liability-list',
      name: 'three-liability-list',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/three-liability/list.vue'),
    },
    {
      path: 'three-liability-insurance-aggregation',
      name: 'three-liability-insurance-aggregation',
      component: () =>
        import(
          /* webpackChunkName: "insurance" */ '@/views/insurance/three-liability/insurance-aggregation.vue'
        ),
    },
    {
      path: 'three-liability-receive-insurance-all',
      name: 'three-liability-receive-insurance-all',
      component: () =>
        import(
          /* webpackChunkName: "insurance" */ '@/views/insurance/three-liability/receive-insurance-all.vue'
        ),
    },
    {
      path: 'three-liability-free-receive',
      name: 'three-liability-free-receive',
      component: () =>
        import(
          /* webpackChunkName: "insurance" */ '@/views/insurance/three-liability/free-receive.vue'
        ),
    },
    {
      path: 'three-liability-third-party-buy',
      name: 'three-liability-third-party-buy',
      component: () =>
        import(
          /* webpackChunkName: "insurance" */ '@/views/insurance/three-liability/third-party-buy.vue'
        ),
    },
    {
      path: 'three-liability-message-center-transfer',
      name: 'three-liability-message-center-transfer',
      component: () =>
        import(
          /* webpackChunkName: "insurance" */ '@/views/insurance/three-liability/message-center-transfer.vue'
        ),
    },
    {
      path: 'service-list',
      name: 'service-list',
      component: () =>
        import(/* webpackChunkName: "insurance" */ '@/views/insurance/service-list.vue'),
    },
  ],
}
export default Insurance
